import { getPaginationParams as extGetPaginationParams, GetParamsInterface, PaginationInterface } from '@bit/jimmijoensson.keyhole.interfaces.paginated-response-interface';

export interface GetParams extends GetParamsInterface {
  orgId?: string
} 

export interface Pagination extends PaginationInterface {
  orgId?: string
} 

export const getPaginationParams = (pagination: Pagination) => ({...extGetPaginationParams(pagination), orgId: pagination.orgId})